import { createHandlerChainRunner } from "@insite/client-framework/HandlerCreator";
import { addDiscontinuedProductsFilter, getFilterIds } from "@tIntermatic/Services/DiscontinuedProductsFilterService";
import { CustomApiHandler } from "@tIntermatic/Store/CustomHandlerCreator";
import { NewsFilterModel } from "@tIntermatic/Types/NewsFilterModel";

type Parameter = {
    filterId: string;
    type: string;
};

type HandlerType = CustomApiHandler<Parameter, NewsFilterModel>;

export const AddDiscontinuedProductFilter: HandlerType = ({ parameter: { filterId, type } }) => {
    addDiscontinuedProductsFilter(filterId, type);
};

export const DispatchSetDiscontinuedProductFilters: HandlerType = ({ dispatch }) => {
    const typeIdList = getFilterIds("type");
    const categoryIdList = getFilterIds("category");
    dispatch({
        type: "Components/DiscontinuedProductListFilter/SetDiscontinuedProductFilterIds",
        typeFilters: typeIdList,
        categoryFilters: categoryIdList,
    });
};

export const chain = [AddDiscontinuedProductFilter, DispatchSetDiscontinuedProductFilters];

const addDiscontinuedProductFilters = createHandlerChainRunner(chain, "AddDiscontinuedProductFilters");
export default addDiscontinuedProductFilters;
